import { createContext } from 'react';

import { initialActionsState } from './actions';
import { initialState } from './reducer';
import * as initialSelectors from './selectors';
import type { ISeedMetadataContextValue } from './types';

export default createContext<ISeedMetadataContextValue>({
  selectors: initialSelectors,
  state: initialState,
  actions: initialActionsState,
});
